import { createContext } from "react";

const TempleTrustContext = createContext({});

export default TempleTrustContext;
